<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="800">
      <template v-slot:activator="{}"> </template>
      <v-card>
        <v-card-title class="h5">
          นโยบายความเป็นส่วนตัวการใช้บริการของวิทยาลัยเทคโนโลยีโปลิเทคนิคลานนา
          เชียงใหม่
        </v-card-title>
        <v-card-text v-html="html"> </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- {{ idAddress }} -->
          <v-btn class="error" large light text @click="updatePDPA()">
            <v-icon left>mdi-check-all</v-icon>
            ยอมรับ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import Axios from "axios";
export default {
  data() {
    return {
      html:
        "ด้วยพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. ๒๕๖๒ เป็นกฎหมายที่มีเจตนารมณ์ปกป้องการล่วงละเมิดและคุ้มครองสิทธิความเป็นส่วนตัวของข้อมูลส่วนบุคคล ได้กำหนดหลักการให้การเก็บรวบรวมใช้หรือเปิดเผยข้อมูลส่วนบุคคลจะต้องขอความยินยอมพร้อมทั้งแจ้งวัตถุประสงค์ให้เจ้าของข้อมูลส่วนบุคคลทราบ โดยชัดแจ้ง จะทำเป็นหนังสือหรือทำผ่านระบบอิเล็กทรอนิกส์ก็ได้<br>" +
        "โดยหนังสือฉบับนี้ วิทยาลัยเทคโนโลยีโปลิเทคนิคลานนา ต่อไปนี้จะเรียก วิทยาลัยฯ ซึ่งมีภารกิจในด้านการจัดการศึกษา ฝึกอบรม การวิจัย และบริหารทางวิชาการและวิชาชีพ มีความประสงค์ขอความยินยอมเก็บรวบรวมข้อมูลส่วนบุคคล สำหรับผู้ที่เข้ารับการศึกษา ฝึกอบรม และผู้ขอรับบริการทางวิชาการและวิชาชีพจากวิทยาลัยฯ เพื่อนำไปใช้ประโยชน์ในการดำเนินการจัดการศึกษา ฝึกอบรม การวิจัยและบริการทางวิชาการและวิชาชีพ<br>" +
        "      	ข้าพเจ้าขอให้ความยินยอมในการเก็บรวบรวมใช้ และเปิดเผยข้อมูลส่วนบุคคลของข้าพเจ้า ดังนี้<br>" +
        "1. ข้าพเจ้ายินยอม ให้วิทยาลัยฯ เก็บรวบรวมใช้ <br>" +
        "      	หรือเปิดเผยข้อมูลส่วนบุคคลของข้าพเจ้าที่ได้ให้ไว้โดยตรงในขณะสมัครเข้าศึกษา สมัครงาน ลงทะเบียน  หรือข้อมูลอื่นที่จำเป็นต้องใช้เกี่ยวกับการดำเนินการจัดการศึกษา<br>" +
        "2. ข้าพเจ้ายินยอม ให้วิทยาลัยฯ เก็บรักษาข้อมูลส่วนบุคคลขอข้าพเจ้า ตราบเท่าที่วัตถุประสงค์ของการนำข้อมูลดังกล่าวไปใช้ยังคงมีอยู่เว้นแต่กรณีจำเป็นต้องเก็บรักษาไว้ต่อไปตามที่กฎหมายกำหนด<br>" +
        "3. ข้าพเจ้ายินยอม ให้วิทยาลัยฯ และผู้ปฏิบัติงานอื่นของวิทยาลัยฯ นำข้อมูลส่วนบุคคลของข้าพเจ้าที่เก็บรวบรวมไปใช้ในการดำเนินการในด้านการจัดการศึกษา และกิจการอื่นใดที่เกี่ยวข้องของวิทยาลัย<br>" +
        "4. ข้าพเจ้ายินยอม ให้วิทยาลัยฯ เปิดเผยข้อมูลส่วนบุคคลของข้าพเจ้าให้แก่หน่วยงานภายนอกตามกฎหมาย และหน่วยงานของรัฐ<br>" +
        "5. วิธีการเพิกถอนความยินยอมและผลการเพิกถอนความยินยอม<br>" +
        "ข้าพเจ้าอาจจเพิกถอนความยินยอมทั้งหมดหรือส่วนใดส่วนหนึ่งตามหนังสือฉบับนี้ โดยข้าพเจ้าจะแจ้งให้วิทยาลัยฯ ทราบเป็นหนังสือและวิทยาลัยฯ อาจขอทราบถึงเหตุผลแห่งการนั้น<br>" +
        "การเพิกถอนความยินยอมของข้าพเจ้าไม่มีผลกระทบต่อการดำเนินการใดๆที่วิทยาลัยฯ ได้ดำเนินการไปแล้ว<br>" +
        "ในกรณีที่ การเพิกถอนความยินยอมเกิดผลกระทบต่อสิทธิหรือหน้าที่ใดๆ ของข้าพเจ้า ข้าพเจ้ายอมรับผลกระทบที่เกิดขึ้นจากการนั้นได้ ",
      idAddress: "",
    };
  },
  props: {
    dialog: { type: Boolean, default: false },
  },
  methods: {
    async updatePDPA() {
      await Axios.post(
        "https://www.lannapoly.ac.th/api/index.php?url=pdpa/set/PDPA_Teacher_test",
        {
          card_id: this.$store.state.dataFrm.tea_card_id,
        }
      ).then(async (res1) => {
        // console.log("Status : " + res1.Status);
        if (res1.data.Status == "1") this.dialog = false;
      });
    },
    ready() {
      Axios.get("http://www.geoplugin.net/json.gp").then((response) => {
        this.idAddress = response.data.geoplugin_request;
      });
    },
  },
  created() {
    this.ready();
  },
};
</script>
